module.exports = __webpack_public_path__ + "img/game-dev.0bdfa8a6.png";